export enum CookieKey {
    LanguageCodePreference = 'languageCodePreference',
    LanguageSuggestionBanner = 'languageSuggestionBannerOff',
    CmsJwtToken = 'CmsJwtToken',
    AdminUserInfoKey = 'adminUserInfo',
    CookiePolicyKey = 'cookiePolicyAccepted',
}
